import Icon from '../../../../shared/components/ui/icons/Icon';
import Tooltip from '../../ui/tooltip/Tooltip';
import classes from "./AddItem.module.css";

const AddItem = ({ text, onClick, icon, height, width, imgSrc, className }) => {

    return (
        <div className={`${classes.AddItem} ${className}`} onClick={onClick} style={{ height, width }}>
            <div className={classes.Content}>
                <div className={classes.AddIcon}>
                    <Icon name={icon} size={61} />
                    {imgSrc && <img src={imgSrc} className={classes.Img} />}
                </div>
                <Tooltip showTooltip text={text}>
                    <p className={classes.Text}>{text}</p>
                </Tooltip>
            </div>
        </div >
    );
};

export default AddItem;
